import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { Link as LinkTo } from 'react-router';
import { BackButton } from "../../../../../common/components/back_button"
import FormContainer from "../../../../../common/components/form_container"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import BottomBar from "../../../../../common/components/bottom_bar"
import { GenerateRateioGeralColumns } from "./columns"
import { useRateioGeralCadastroViewModel } from "../../viewModels/rateio_geral_cadastro_view_model"
import { RateioGeralLista } from "../../../domain/models/rateio_geral_listas"
import { CadastroCentroCustoRateioModal } from "./components/cadastro_centro_custo_rateio"


export const RateioGeralCadastro = () => {

    const viewModel = useRateioGeralCadastroViewModel();

    const columnsDef = useMemo(() => {
        return GenerateRateioGeralColumns({
            OnActionValorChange: viewModel.handleValorChange,
        });
    }, [
        viewModel.handleValorChange,
    ]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <BackButton
                                onClick={() => viewModel.handlePageBack()} />

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.setOpenCadastroCentroCustoRateioModal(true)}>
                                    Incluir Centro de Custo
                                </PrimaryButton>

                            </div>

                        </div>
                    }
                />
            </PageTopBar >

            <form className="pb-8" >
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Home
                        </Link>
                        <Link underline="hover" color="inherit">
                            <LinkTo to="/RateioGeral_lista" >Rateio Geral Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Rateio Geral Cadastro
                        </Typography>
                    </Breadcrumbs>

                    <div className="div flex justify-start items-center flex-col md:flex-row gap-6 md:gap-0">

                        <div className="grid grid-cols-1  items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Rateio Geral Cadastro
                            </h1>
                            <div className="flex gap-2 items-center w-full">
                                {viewModel.rateioGeralContaPagar && (
                                    <div className="w-full mt-3 text-black dark:text-white p-4 rounded-xl bg-gray-100 dark:bg-gray-800 shadow-sm">

                                        <div className="text-lg">
                                            <span className="font-semibold mr-2">N° Conta a Pagar:</span>
                                            <span className="font-bold">{viewModel.rateioGeralContaPagar.nroContaPagar}</span>
                                        </div>

                                        <div className="text-lg ">
                                            <span className="font-semibold mr-2">Data Pagamento:</span>
                                            <span className="font-bold">
                                                {viewModel.rateioGeralContaPagar.dataPagar
                                                    ? new Date(viewModel.rateioGeralContaPagar.dataPagar).toLocaleDateString("pt-BR")
                                                    : ""}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                <RefreshButton onClick={viewModel.handleReload} />
                            </div>
                        </div>
                    </div>

                    {
                        viewModel.errorMessage !== undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={viewModel.errorMessage}
                                    onTryAgain={viewModel.handleReload} />
                            </div>
                        ) : (
                            <>
                                <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                                    <FormContainer title="" arrangement="fullRow" border={false}>
                                        <div className="flex flex-col items-start w-full gap-4">

                                        </div>
                                    </FormContainer>

                                    <Stack spacing={0}>
                                        <div className="text-lg">
                                            <span className="font-semibold mr-2">Valor Pagar:</span>
                                            <span className="font-bold">{(viewModel.rateioGeralContaPagar?.valorPagar)?.toLocaleString("pt-BR", {
                                                style: "currency",
                                                currency: "BRL"
                                            })}</span>
                                        </div>
                                        <div className="w-full flex flex-row justify-between items-stretch">

                                            <div className="flex flex-col justify-between flex-1">
                                                <TablePagination
                                                    component="div"
                                                    count={viewModel.pagination.totalItems}
                                                    page={viewModel.pagination.page - 1}
                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                                    rowsPerPage={viewModel.pagination.rowsPerPage}
                                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                            </div>

                                        </div>

                                        <StyledDataGrid
                                            apiRef={viewModel.apiRef}
                                            tableName="reajuste_cadastro_lista"
                                            disableColumnMenu={false}
                                            showToolbar={true}
                                            disableRowSelectionOnClick={true}
                                            getRowId={(row: RateioGeralLista) => row.idRateioGeral}
                                            columns={columnsDef}
                                            loading={viewModel.loading}
                                            checkboxSelection={false}
                                            rows={viewModel.rateioGeralLista}
                                            rowCount={viewModel.rateioGeralLista.length}
                                            pageSizeOptions={[10, 25, 50, 100]}
                                            paginationMode="server"
                                            paginationModel={{
                                                page: viewModel.pagination.page,
                                                pageSize: viewModel.pagination.rowsPerPage,
                                            }}
                                        />

                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                        />
                                    </Stack>
                                </div>
                            </>
                        )
                    }

                </div>

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            {/* {
                                viewModel. &&
                                <>
                                    <div>
                                        <PrimaryButton
                                            buttonColor="yellow"
                                            onClick={() => viewModel.handleOpenChangeHistory(viewModel.selectedIdRateioGeral ?? null, null)}>
                                            <span className="text-xs">
                                                Historico de alterações
                                            </span>
                                        </PrimaryButton>
                                    </div>
                                </>
                            } */}
                        </div>

                        <div className="w-full h-full flex justify-end items-center p-4 gap-6">

                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        onClick={viewModel.handleSubmitValoresRateios}
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form>

            <CadastroCentroCustoRateioModal
                open={viewModel.openCadastroCentroCustoRateioModal}
                saving={viewModel.saving}
                ddlCentroCusto={viewModel.ddlCentroCusto ?? []}
                selectedIdsCentroCusto={viewModel.selectedIdsCentroCusto}
                handleIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
                onSubmit={viewModel.handleSubmitCentroCustoRateio}
                onClose={() => viewModel.setOpenCadastroCentroCustoRateioModal(false)}

            />

            <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
        </>
    )
}



